import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = { class: "space-y-2" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "relative w-full max-w-md h-36" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center rounded-lg border border-dashed border-gray-300 text-black bg-gray-50"
}
const _hoisted_11 = { class: "w-full max-w-md flex items-center gap-3" }
const _hoisted_12 = { class: "space-y-4" }
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "relative w-full max-w-md h-36" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center rounded-lg border border-dashed border-gray-300 text-black bg-gray-50"
}
const _hoisted_18 = { class: "w-full max-w-md flex items-center gap-3" }
const _hoisted_19 = { class: "space-y-4" }
const _hoisted_20 = { class: "space-y-2" }
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = { class: "relative w-full max-w-md h-36" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center rounded-lg border border-dashed border-gray-300 text-black bg-gray-50"
}
const _hoisted_25 = { class: "w-full max-w-md flex items-center gap-3" }

import { ref, computed, watch, nextTick } from 'vue'
import { DataCard } from '@/components'
import { ImageUrls, UploadedImages } from '@/types/generalInformation'

import { onBeforeUnmount } from 'vue'
interface Props {
  imageUrls?: ImageUrls
  saving?: boolean
  disableSave?: boolean
}

interface Emits {
  (e: 'images-changed', images: UploadedImages): void
  (e: 'save'): void
  (e: 'delete-image', type: 'banniere' | 'square' | 'logo-boutique'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImagesSection',
  props: {
    imageUrls: {},
    saving: { type: Boolean },
    disableSave: { type: Boolean }
  },
  emits: ["images-changed", "save", "delete-image"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emit = __emit

// URLs des images depuis les props
const logoUrl = computed(() => props.imageUrls?.logo || '')
const banniereUrl = computed(() => props.imageUrls?.banniere || '')
const squareUrl = computed(() => props.imageUrls?.square || '')

// Visibilité des aperçus (masque si l'image n'existe pas ou échoue à charger)
const showBanner = ref(!!banniereUrl.value)
const showSquare = ref(!!squareUrl.value)
const showLogo = ref(!!logoUrl.value)

// Prévisualisation locale des images sélectionnées
const bannerPreviewUrl = ref<string>('')
const squarePreviewUrl = ref<string>('')
const logoPreviewUrl = ref<string>('')

const currentBannerUrl = computed(() => bannerPreviewUrl.value || banniereUrl.value)
const currentSquareUrl = computed(() => squarePreviewUrl.value || squareUrl.value)
const currentLogoUrl = computed(() => logoPreviewUrl.value || logoUrl.value)

// Réagir aux changements d'URLs (ex: rechargement après sauvegarde)
watch(banniereUrl, (v) => {
  // Si une nouvelle URL serveur arrive, on bascule dessus et on nettoie la prévisualisation locale
  if (v) {
    if (bannerPreviewUrl.value) {
      URL.revokeObjectURL(bannerPreviewUrl.value)
      bannerPreviewUrl.value = ''
    }
  }
  showBanner.value = !!v || !!bannerPreviewUrl.value
})
watch(squareUrl, (v) => {
  if (v && squarePreviewUrl.value) {
    URL.revokeObjectURL(squarePreviewUrl.value)
    squarePreviewUrl.value = ''
  }
  showSquare.value = !!v || !!squarePreviewUrl.value
})
watch(logoUrl, (v) => {
  if (v && logoPreviewUrl.value) {
    URL.revokeObjectURL(logoPreviewUrl.value)
    logoPreviewUrl.value = ''
  }
  showLogo.value = !!v || !!logoPreviewUrl.value
})

// État des images uploadées
const uploadedImages = ref<UploadedImages>({
  logo: null,
  banniere: null,
  square: null
})

// Fonction de validation de la taille des fichiers (2 Mo max)
const validateFileSize = (file: File, type: string): boolean => {
  const maxSize = 2 * 1024 * 1024 // 2 Mo en bytes
  if (file.size > maxSize) {
    alert(`❌ Le fichier ${type} est trop volumineux. Taille maximale autorisée : 2 Mo`)
    return false
  }
  return true
}

// Handlers d'upload
const handleBannerUpload = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0]
  if (file) {
    if (validateFileSize(file, 'bannière')) {
      uploadedImages.value.banniere = file
      // Mettre à jour l'aperçu local immédiatement
      if (bannerPreviewUrl.value) {
        URL.revokeObjectURL(bannerPreviewUrl.value)
      }
      bannerPreviewUrl.value = URL.createObjectURL(file)
      showBanner.value = true
      emit('images-changed', uploadedImages.value)
      nextTick(() => emit('save'))
    } else {
      // Réinitialiser l'input si le fichier est trop volumineux
      (event.target as HTMLInputElement).value = ''
    }
  }
}

const handlePosterUpload = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0]
  if (file) {
    if (validateFileSize(file, 'affiche')) {
      uploadedImages.value.square = file
      // Prévisualisation immédiate
      if (squarePreviewUrl.value) {
        URL.revokeObjectURL(squarePreviewUrl.value)
      }
      squarePreviewUrl.value = URL.createObjectURL(file)
      showSquare.value = true
      emit('images-changed', uploadedImages.value)
      nextTick(() => emit('save'))
    } else {
      // Réinitialiser l'input si le fichier est trop volumineux
      (event.target as HTMLInputElement).value = ''
    }
  }
}

const handleLogoUpload = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0]
  if (file) {
    if (validateFileSize(file, 'logo-boutique')) {
      uploadedImages.value.logo = file
      // Prévisualisation immédiate
      if (logoPreviewUrl.value) {
        URL.revokeObjectURL(logoPreviewUrl.value)
      }
      logoPreviewUrl.value = URL.createObjectURL(file)
      showLogo.value = true
      emit('images-changed', uploadedImages.value)
      nextTick(() => emit('save'))
    } else {
      // Réinitialiser l'input si le fichier est trop volumineux
      (event.target as HTMLInputElement).value = ''
    }
  }
}


// Handlers de suppression
const deleteBanner = () => {
  uploadedImages.value.banniere = null
  if (bannerPreviewUrl.value) {
    URL.revokeObjectURL(bannerPreviewUrl.value)
    bannerPreviewUrl.value = ''
  }
  showBanner.value = false
  emit('delete-image', 'banniere')
}

const deletePoster = () => {
  uploadedImages.value.square = null
  if (squarePreviewUrl.value) {
    URL.revokeObjectURL(squarePreviewUrl.value)
    squarePreviewUrl.value = ''
  }
  showSquare.value = false
  emit('delete-image', 'square')
}

const deleteLogo = () => {
  uploadedImages.value.logo = null
  if (logoPreviewUrl.value) {
    URL.revokeObjectURL(logoPreviewUrl.value)
    logoPreviewUrl.value = ''
  }
  showLogo.value = false
  emit('delete-image', 'logo-boutique')
}

// récupérer les images uploadées 
const getUploadedImages = () => {
  return uploadedImages.value
}

// Exposer la fonction au parent
__expose({
  getUploadedImages
})

// Nettoyer l'URL objet lors du démontage du composant
onBeforeUnmount(() => {
  if (bannerPreviewUrl.value) {
    URL.revokeObjectURL(bannerPreviewUrl.value)
  }
  if (squarePreviewUrl.value) {
    URL.revokeObjectURL(squarePreviewUrl.value)
  }
  if (logoPreviewUrl.value) {
    URL.revokeObjectURL(logoPreviewUrl.value)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataCard), {
    title: "Images et médias",
    icon: "fas fa-images",
    "icon-color": "text-orange-600",
    "icon-bg-color": "bg-orange-100",
    class: "w-full"
  }, {
    "header-actions": _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save'))),
        disabled: _ctx.saving || _ctx.disableSave,
        class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
      }, [
        (_ctx.saving)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createElementBlock("i", _hoisted_3)),
        _createElementVNode("span", null, _toDisplayString(_ctx.saving ? "Sauvegarde..." : "Sauvegarder"), 1)
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Bannières", -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-black" }, " L'image doit être au format JPG et inférieure à 2 Mo, dimension conseillée : 1500x590 pixels ", -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-black mb-2" }, "Image actuelle :", -1)),
              _createElementVNode("div", _hoisted_8, [
                (showBanner.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: currentBannerUrl.value,
                      alt: "Bannière actuelle",
                      class: "w-full h-full object-contain rounded-lg border border-gray-300 bg-white",
                      onError: _cache[1] || (_cache[1] = ($event: any) => (showBanner.value = false))
                    }, null, 40, _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, " Aucune bannière "))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("input", {
                type: "file",
                accept: ".jpg,.jpeg",
                onChange: handleBannerUpload,
                class: "block w-full text-sm text-black file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              }, null, 32),
              (showBanner.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: deleteBanner,
                    class: "flex-shrink-0 px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center gap-1"
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "fas fa-trash text-xs" }, null, -1),
                    _createTextVNode(" Supprimer ")
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Affiches", -1)),
          _createElementVNode("div", _hoisted_13, [
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm text-black" }, " L'image doit être au format JPG et inférieure à 2 Mo, dimension conseillée : 250x192 pixels ", -1)),
            _createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-black mb-2" }, "Image actuelle :", -1)),
              _createElementVNode("div", _hoisted_15, [
                (showSquare.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: currentSquareUrl.value,
                      alt: "Affiche actuelle",
                      class: "w-full h-full object-contain rounded-lg border border-gray-300 bg-white",
                      onError: _cache[2] || (_cache[2] = ($event: any) => (showSquare.value = false))
                    }, null, 40, _hoisted_16))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, " Aucune affiche "))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("input", {
                type: "file",
                accept: ".jpg,.jpeg",
                onChange: handlePosterUpload,
                class: "block w-full text-sm text-black file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              }, null, 32),
              (showSquare.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: deletePoster,
                    class: "flex-shrink-0 px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center gap-1"
                  }, _cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "fas fa-trash text-xs" }, null, -1),
                    _createTextVNode(" Supprimer ")
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Logo", -1)),
          _createElementVNode("div", _hoisted_20, [
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm text-black" }, " L'image doit être au format JPG et inférieure à 2 Mo, limite dimension : 345px max de largeur ", -1)),
            _createElementVNode("div", _hoisted_21, [
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm text-black mb-2" }, "Image actuelle :", -1)),
              _createElementVNode("div", _hoisted_22, [
                (showLogo.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: currentLogoUrl.value,
                      alt: "Logo actuel",
                      class: "w-full h-full object-contain rounded-lg border border-gray-300 bg-white",
                      onError: _cache[3] || (_cache[3] = ($event: any) => (showLogo.value = false))
                    }, null, 40, _hoisted_23))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, " Aucun logo "))
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("input", {
                type: "file",
                accept: ".jpg,.jpeg",
                onChange: handleLogoUpload,
                class: "block w-full text-sm text-black file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              }, null, 32),
              (showLogo.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: deleteLogo,
                    class: "flex-shrink-0 px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center gap-1"
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fas fa-trash text-xs" }, null, -1),
                    _createTextVNode(" Supprimer ")
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})